import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vuetify from './plugins/vuetify'
import { JazelAppConfig } from '@jazel/jazel-vuetify'
import { config } from './config/generated-config'
import App from './App.vue'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(vuetify)
app.use(pinia)
app.use(JazelAppConfig, {
  productId: 'micro_srp',
  isEmbedded:
    document.getElementById('micro-srp-admin')?.parentNode !== document.body,
  cdnUrl: config.VITE_CDN_URL,
  jamsFrontendUrl: config.VITE_JAMS_FRONTEND_URL,
  jamsBackendUrl: config.VITE_JAMS_BACKEND_URL,
})
app.mount('#micro-srp-admin')
